import global from '../global'

const reRetrieval = global.serverUrl + '/file/zone/re_retrieval'
const fileKeyCheck = global.serverUrl + '/file/key/check'
export default {
  reRetrieval,
  fileKeyCheck
}



// WEBPACK FOOTER //
// ./src/config/api/file.js